module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content",
    attrs: {
      "id": "deviceuserlist"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowEmptyList),
      expression: "isShowEmptyList"
    }],
    staticClass: "accessory-list-default"
  }, [_c('img', {
    staticClass: "center-block accessory-list-no-matching-img",
    attrs: {
      "src": require("../../../static/img/icon_no_matching_result.svg")
    }
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _vm._l((_vm.userList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "agent-list",
      attrs: {
        "value": _vm.userList
      }
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-lg-1 col-md-2 col-sm-2 col-xs-3"
    }, [(item.photo == '') ? _c('img', {
      staticClass: "device-user-list-portrait",
      attrs: {
        "src": require("../../../static/img/img_device_user_default.png")
      }
    }) : _c('img', {
      staticClass: "device-user-list-portrait",
      attrs: {
        "src": 'https://d.din.bz/' + item.photo
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-7 col-md-6 col-sm-10 col-xs-9 device-user-list-data"
    }, [_c('span', {
      staticClass: "device-user-list-username"
    }, [_vm._v(_vm._s(item.uid))]), _vm._v(" "), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!item.isShowDevice),
        expression: "!item.isShowDevice"
      }],
      staticClass: "device-user-list-devicename",
      attrs: {
        "id": item.uid + 'showdevicebtn'
      }
    }, [_c('button', {
      staticClass: "btn btn-xs btn-default",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.toLoadMoreDevice(item.uid, index)
        }
      }
    }, [_vm._v("show the binding device")])]), _vm._v(" "), _vm._l((item.devices), function(device) {
      return _c('div', {
        key: device.deviceid,
        staticClass: "row",
        attrs: {
          "id": item.uid
        }
      }, [_c('p', {
        staticClass: "col-sm-11 col-xs-10 device-user-list-show-device-name-mar device-user-list-show-device-name-go-to",
        attrs: {
          "id": item.uid + 'devicelist'
        },
        on: {
          "click": function($event) {
            _vm.toSearchDevice(device.devicename, device.deviceid)
          }
        }
      }, [_vm._v("\n            " + _vm._s(device.devicename) + "\n            "), _c('span', {
        staticClass: "device-user-list-show-device-id"
      }, [_vm._v("\n              (\n              "), _c('span', [_vm._v(_vm._s(device.deviceid))]), _vm._v(" )\n            ")])]), _vm._v(" "), _c('button', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.toGetDevice(index)),
          expression: "toGetDevice(index)"
        }],
        staticClass: "btn btn-xs btn-default pull-right col-sm-1 col-xs-2 device-user-list-show-device-name-mar",
        attrs: {
          "type": "button",
          "data-toggle": "modal",
          "data-target": "#device-user-list-set-device"
        },
        on: {
          "click": function($event) {
            _vm.toShowDevicePermission(device, index)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-edit (alias)"
      })])])
    }), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.isShowNone),
        expression: "item.isShowNone"
      }],
      staticClass: "row",
      attrs: {
        "id": item.uid + 'emptydevice'
      }
    }, [_vm._m(1, true)])], 2), _vm._v(" "), _c('div', {
      staticClass: "col-lg-4 col-md-4 col-sm-12 col-xs-12 btn-device-user-list"
    }, [_c('button', {
      staticClass: "btn btn-info btn-sm btn-agent-edit pull-right",
      attrs: {
        "data-toggle": "modal",
        "data-target": "#modal-user-add-device"
      },
      on: {
        "click": function($event) {
          _vm.toAddDevice(item.uid)
        }
      }
    }, [_vm._v("Add Device")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-primary btn-sm btn-device-user-list-setting pull-right",
      attrs: {
        "data-toggle": "modal",
        "data-target": "#modal-user-profile"
      },
      on: {
        "click": function($event) {
          _vm.toProfile(item, index)
        }
      }
    }, [_vm._v("Profile")])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "add-app-bgcolor",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#modal-new-a-device-user"
    },
    on: {
      "click": _vm.toAddUser
    }
  }, [_vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "modal fade in",
    attrs: {
      "id": "modal-user-profile"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group modal-user-profile-head"
  }, [_vm._m(4), _vm._v(" "), (_vm.currentProfileUser.photo == '') ? _c('img', {
    staticClass: "modal-user-profile-img modal-user-profile-head-img",
    attrs: {
      "src": require("../../../static/img/img_device_user_default.png")
    }
  }) : _c('img', {
    staticClass: "modal-user-profile-img",
    attrs: {
      "src": 'https://d.din.bz/' + _vm.currentProfileUser.photo
    }
  }), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.currentProfileUser.uid))])]), _vm._v(" "), _c('div', {
    staticClass: "input-group form-group modal-user-profile-content"
  }, [_vm._m(5), _vm._v(" "), _c('input', {
    staticClass: "form-control modal-user-profile-input",
    attrs: {
      "id": "current_password",
      "placeholder": "Keep the current password"
    },
    domProps: {
      "value": _vm.currentProfileUser.password
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group form-group modal-user-profile-content"
  }, [_vm._m(6), _vm._v(" "), _c('input', {
    staticClass: "form-control modal-user-profile-input",
    attrs: {
      "id": "current_email",
      "placeholder": "Email Address"
    },
    domProps: {
      "value": _vm.currentProfileUser.mail
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group form-group modal-user-profile-content"
  }, [_vm._m(7), _vm._v(" "), _c('input', {
    staticClass: "form-control modal-user-profile-input",
    attrs: {
      "id": "current_phone",
      "placeholder": "Phone Number"
    },
    domProps: {
      "value": _vm.getPhone(_vm.currentProfileUser.phone)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-btn"
  }, [_c('select', {
    staticClass: "btn btn-warning modal-user-profile-area-code",
    attrs: {
      "id": "current_phone_zone"
    },
    domProps: {
      "value": _vm.getPhoneZone(_vm.currentProfileUser.phone)
    }
  }, _vm._l((_vm.phonezonelist), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": _vm.phonezonelist[index]
      }
    }, [_vm._v(_vm._s(_vm.phonezonelist[index] + ' ' + _vm.phonezonaname[index]))])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default pull-left",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toDoUpdataUser
    }
  }, [_vm._v("Save changes")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade in",
    attrs: {
      "id": "modal-user-add-device"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(8), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("\n            Add Device\n            "), _c('i', {
    staticClass: "fa fa-angle-right modal-device-user-title-name"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.currentAddDevice.uid))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "row modal-user-setting-add-device-row"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8 modal-user-setting-table-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentAddDevice.deviceid),
      expression: "currentAddDevice.deviceid"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Input the Device ID"
    },
    domProps: {
      "value": (_vm.currentAddDevice.deviceid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentAddDevice, "deviceid", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3 modal-user-setting-auth-add"
  }, [_c('span', [_vm._v("Authority: ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentAddDevice.permission),
      expression: "currentAddDevice.permission"
    }],
    staticClass: "choose-existing-agent-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.currentAddDevice, "permission", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "30"
    }
  }, [_vm._v("Admin")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "20"
    }
  }, [_vm._v("User")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("Guest")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default pull-left",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toDoAddDevice
    }
  }, [_vm._v("Save changes")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade in",
    attrs: {
      "id": "device-user-list-set-device"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(10), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("\n            Authority Management\n            "), _c('i', {
    staticClass: "fa fa-angle-right modal-device-user-title-name"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.currentUserDeviceSetting.username))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "row modal-user-setting-add-device-row"
  }, [_vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8 modal-user-setting-table-input"
  }, [_c('p', {
    staticClass: "device-user-list-show-device-name"
  }, [_vm._v("\n                  " + _vm._s(_vm.currentUserDeviceSetting.devicename) + "\n                  "), _c('span', {
    staticClass: "device-user-list-show-device-id"
  }, [_vm._v("(" + _vm._s(_vm.currentUserDeviceSetting.deviceid) + ")")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3 modal-user-setting-auth-add modal-user-setting-auth-sel"
  }, [_c('span', [_vm._v("Authority: ")]), _vm._v(" "), _c('select', {
    staticClass: "choose-existing-agent-select",
    attrs: {
      "id": "change_device_permission"
    },
    domProps: {
      "value": _vm.currentUserDeviceSetting.permission
    }
  }, [_c('option', {
    attrs: {
      "value": "30"
    }
  }, [_vm._v("Admin")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "20"
    }
  }, [_vm._v("User")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("Guest")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-danger pull-left",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_vm._v("Unbind")]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu pull-left alert-del"
  }, [_vm._m(12), _vm._v(" "), _c('li', [_c('button', {
    staticClass: "btn btn-default"
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.toUnbindUser
    }
  }, [_vm._v("Unbind")])])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toChangPermission
    }
  }, [_vm._v("Save changes")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade in",
    attrs: {
      "id": "modal-new-a-device-user"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-xs-3 control-label agent-edit-modal-name"
  }, [_vm._v("Username")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-9 agent-edit-modal-name"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentAddDeviceUser.uid),
      expression: "currentAddDeviceUser.uid"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "User ID"
    },
    domProps: {
      "value": (_vm.currentAddDeviceUser.uid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentAddDeviceUser, "uid", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-xs-3 control-label agent-edit-modal-name"
  }, [_vm._v("Password")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-9 agent-edit-modal-name"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentAddDeviceUser.password),
      expression: "currentAddDeviceUser.password"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Keep the default password(123456)"
    },
    domProps: {
      "value": (_vm.currentAddDeviceUser.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentAddDeviceUser, "password", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-xs-3 control-label agent-edit-modal-name"
  }, [_vm._v("Email Address")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-9 agent-edit-modal-name"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentAddDeviceUser.mail),
      expression: "currentAddDeviceUser.mail"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "(Optional)"
    },
    domProps: {
      "value": (_vm.currentAddDeviceUser.mail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentAddDeviceUser, "mail", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-xs-3 control-label agent-edit-modal-name"
  }, [_vm._v("Mobile Phone")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-9 agent-edit-modal-name"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentAddDeviceUser.phone),
      expression: "currentAddDeviceUser.phone"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "(Optional)"
    },
    domProps: {
      "value": (_vm.currentAddDeviceUser.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentAddDeviceUser, "phone", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "new-device-user-area-code"
  }, [_c('select', {
    staticClass: "btn btn-warning modal-user-profile-area-code",
    attrs: {
      "id": ""
    },
    domProps: {
      "value": _vm.getPhoneZone(_vm.currentProfileUser.phone)
    }
  }, _vm._l((_vm.phonezonelist), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": _vm.phonezonelist[index]
      }
    }, [_vm._v(_vm._s(_vm.phonezonelist[index] + ' ' + _vm.phonezonaname[index]))])
  }), 0)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default pull-left",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toDoAddUser
    }
  }, [_vm._v("Save changes")])])])])])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center col-sm-6 col-sm-offset-3"
  }, [_c('h4', {
    staticClass: "page-404-tips"
  }, [_vm._v("This user is maybe not registered on this platform.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "col-xs-11 device-user-list-show-device-name"
  }, [_c('span', {
    staticClass: "device-user-list-show-device-id"
  }, [_vm._v("none")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "add-app-btn"
  }, [_c('span', {
    staticClass: "btn add-app"
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("User Profile")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-self-profile-upload-head modal-user-profile-head-input"
  }, [_c('input')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-key"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon modal-user-profile-content-icon"
  }, [_c('i', {
    staticClass: "fa fa-phone"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-1"
  }, [_c('i', {
    staticClass: "fa fa-desktop modal-user-setting-icon"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-1"
  }, [_c('i', {
    staticClass: "fa fa-desktop"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('i', {
    staticClass: "icon fa fa-warning alert-del-warning"
  }), _vm._v("Confirm to unbind?\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("New a Device User")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-62a22ffd", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62a22ffd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/DeviceUser.vue
// module id = 475
// module chunks = 1